import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('Country', CountryData);

    CountryData.$inject = ['$translate', 'logger'];

    /* @ngInject */
    function CountryData($translate, logger) {
        Country.prototype = {
            build: build
        };

        function Country(countryData) {
            if (countryData) {
                this.build(countryData);
            }
        }

        return Country;

        /////////////////////

        function build(countryData) {
            if (countryData) {
                this.code = countryData.code || null;
                this.fromEU = countryData.fromEU || null;
                this.label = _getLabel(countryData.code);
                this.labelWithCode = _getLabelWithCode(countryData.code);
                this.text = this.labelWithCode

            } else {
                logger.error('Error with country', countryData);
            }
        }

        function _getLabel(code) {
            if (code) {
                return $translate.instant('country.' + angular.lowercase(code));
            }
            return '';
        }

        function _getLabelWithCode(code) {
            if (code) {
                return $translate.instant('country.' + angular.lowercase(code)) + ' (' + code + ')';
            }
            return '';
        }
    }
})();
